(ns web3.tracking.sentry
  (:require ["@sentry/browser" :as Sentry]
            [web3.log :as log]
            [web3.env :as env]
            [re-frame.core :as rf]
            [applied-science.js-interop :as j]))

(def SENTRY_DSN (env/config :SENTRY_DSN))

(defn append-log [data]
  ;; NOTE
  ;; these logs are currently being "FILTERED" by Sentry.
  ;; need to adjust sentry project settings to fix that.
  (when SENTRY_DSN
    (let [log-data (try (log/tail-string) (catch js/Error e "Printing log failed"))]
      (j/assoc-in! data [:extra :web3Log] log-data))))

(defn init []
  (when SENTRY_DSN
    (.init Sentry #js{:dsn SENTRY_DSN
                      :release (env/config :release)
                      :environment (env/config :release-flag)
                      :dataCallback append-log})
    (.configureScope Sentry #(.setTag % "stack" (env/config :STACKNAME)))))

(defn identify [email]
  (when SENTRY_DSN
    (.configureScope Sentry #(.setUser % #js{:email email}))))

(rf/reg-fx :sentry/set-user-context
           (fn [email]
             (identify email)))

(defn breadcrumb!
  "Takes a map of:
  * `:message` - a string describing the event
  * `:data` - a map of data about the event
  * `:category` - a category with which to label the event
  * `:level` - one of `:debug`, `:info`, `:warn`, or `:error`"
  [m]
  (when SENTRY_DSN
    (.addBreadcrumb Sentry (clj->js m))))



(defn capture-exception [error]
  (when SENTRY_DSN
    (try
      (js/JSON.stringify error)
      (Sentry/captureException error)
      (catch js/TypeError e
        ;;Catch on circular reference and just print what we have
        (Sentry/captureException (with-out-str (print error)))))))
